<template>
    <div>
        <DFabs>
            <DFab
                id="download-upload"
                icon="download"
                :label="__('products.download_upload.download')"
                @click="download"
            />
            <DFab
                id="download-upload-upload"
                icon="upload"
                :label="__('products.download_upload.upload')"
                @click="upload"
            />
        </DFabs>
        <ProductPlanImportHistoryTable
            :imports="imports"
            index-route="products.product-addons.download-upload"
            download-route="products.plans.import.download"
            backup-download-route="products.plans.import.download-backup"
            retry-route="products.product-addons.plans.import.retry.show"
            type="addon"
        />
    </div>
</template>

<script setup>
import { route } from '~@/Composables/route'
import { __ } from '~@/Composables/translation'
import { router } from '@inertiajs/vue3'
import ProductPlanImportHistoryTable from '~@/Components/Products/Products/ProductPlanImportHistoryTable.vue'

defineProps({
    imports: {
        type: Object,
        required: true,
    },
})

function download () {
    const link = document.createElement('a')
    link.href = route('products.product-addons.download')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}

const upload = () => router.get(route('products.product-addons.plans.import.create'))
</script>
